(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const GRID_ID = "collection-grid";
    const CONTAINER_ID = "container-grid";

/** Template JSON section key for ?section_id= (e.g. main) */
    const SECTION_TEMPLATE_KEY = "{{ section.id | split: '__' | last }}";
    const loader = () => document.getElementById("infinite-loader");

    let debounceTimer;
    let loading = false;

    function qs(selector, root = document) {
      return root.querySelector(selector);
    }
    function qsa(selector, root = document) {
      return Array.from(root.querySelectorAll(selector));
    }
    function debounced(fn, delay = 300) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(fn, delay);
    }

    function getFilterParams() {
      const params = new URLSearchParams();
      qsa(".options__body input[type='checkbox']:checked").forEach((cb) => {
        if (cb.closest("#category-filter")) return;
        


        params.append(cb.name, cb.value);
      });
      const min = document.getElementById("price-min") ?. value;
      const max = document.getElementById("price-max") ?. value;
      if (min) 
        params.set("filter.v.price.gte", min);
      


      if (max) 
        params.set("filter.v.price.lte", max);
      


      return params;
    }

    function initFilters() {
      qsa(".options__body input[type='checkbox']").forEach((cb) => {
        if (cb.closest("#category-filter")) return;
        


        cb.onchange = () => debounced(applyFilters, 220);
      });
      qsa("#price-filter input").forEach((inp) => {
        inp.oninput = () => debounced(applyFilters, 350);
      });
      qsa(".reset-btn").forEach((btn) => {
        btn.onclick = (e) => {
          e.preventDefault();
          resetFilter(btn.dataset.filter);
        };
      });

      window.onpopstate = () => restoreState();

      initCategoryFilterLinks();
    }

    function resetFilter(type) {
      if (type === "category") {
        qsa("#category-filter input:checked").forEach((i) => (i.checked = false));
      } else if (type === "price") {
        if (document.getElementById("price-min")) 
          document.getElementById("price-min").value = "";
        


        if (document.getElementById("price-max")) 
          document.getElementById("price-max").value = "";
        


      } else if (type === "gender") {
        qsa("#gender-filter input:checked").forEach((i) => (i.checked = false));
      } else if (type === "color") {
        qsa("#color-filter input:checked").forEach((i) => (i.checked = false));
      } else if (type === "size") {
        qsa("#size-filter input:checked").forEach((i) => (i.checked = false));
      }
      applyFilters();
    }

    function initCategoryFilterLinks() {
      const categorySelect = qs("#category-filter");
      if (! categorySelect) return;
      


      const links = qsa("#category-filter [data-category-link]");
      links.forEach((link) => {
        link.addEventListener("click", () => {
          categorySelect.removeAttribute("open");
        });
      });
    }

    async function applyFilters() {
      const params = getFilterParams();
      const url = `${
        window.location.pathname
      }${
        params.toString()
          ? "?" + params.toString()
          : ""
        }`;

      try {
        const res = await fetch(url, {credentials: "same-origin"});
        if (! res.ok) 
          throw new Error("Network error while applying filters");
        


        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");

        const newSection = doc.getElementById(GRID_ID);
        const curSection = document.getElementById(GRID_ID);
        if (newSection && curSection) {
          curSection.innerHTML = newSection.innerHTML;
        } else {
          const newContainer = doc.getElementById(CONTAINER_ID);
          const curContainer = document.getElementById(CONTAINER_ID);
          if (newContainer && curContainer) 
            curContainer.replaceWith(newContainer);
          


        }

        const newCount = doc.getElementById("product-count") ?. textContent;
        if (newCount) {
          const countEl = document.getElementById("product-count");
          if (countEl) 
            countEl.textContent = newCount;
          


        }

        window.history.pushState({}, "", url);

        initFilters();
        initInfiniteScroll();

        if (window.initProductCards) {
          window.initProductCards();
        }
      } catch (err) {
        console.error("applyFilters:", err);
      }
    }

    async function restoreState() {
      try {
        const res = await fetch(window.location.href, {credentials: "same-origin"});
        if (! res.ok) 
          throw new Error("Network error while restoring state");
        


        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        const newSection = doc.getElementById(GRID_ID);
        if (newSection && document.getElementById(GRID_ID)) {
          document.getElementById(GRID_ID).innerHTML = newSection.innerHTML;
        } else {
          const newContainer = doc.getElementById(CONTAINER_ID);
          if (newContainer && document.getElementById(CONTAINER_ID)) {
            document.getElementById(CONTAINER_ID).replaceWith(newContainer);
          }
        }
        const newCount = doc.getElementById("product-count") ?. textContent;
        if (newCount) 
          document.getElementById("product-count").textContent = newCount;
        


        initFilters();
        initInfiniteScroll();

        if (window.initProductCards) {
          window.initProductCards();
        }
      } catch (err) {
        console.error("restoreState:", err);
      }
    }

    function initInfiniteScroll() {
      if (window._collectionScrollHandler) {
        window.removeEventListener("scroll", window._collectionScrollHandler);
        window._collectionScrollHandler = null;
      }

      window._collectionScrollHandler = function() {
        if (loading) return;
        


        const nextLink = qs(".next-page-link");
        if (! nextLink) return;
        


        const scrollPosition = window.innerHeight + window.scrollY;
        const bottomOffset = document.body.offsetHeight * 0.82;
        if (scrollPosition >= bottomOffset) {
          loadNextPage(nextLink.href);
        }
      };

      window.addEventListener("scroll", window._collectionScrollHandler);
    }

    async function loadNextPage(rawHref) {
      if (loading) return;
      


      loading = true;
      const loaderEl = loader();
      if (loaderEl) 
        loaderEl.style.display = "block";
      


      try {
        const fetchUrl = new URL(rawHref, location.origin);
        const params = getFilterParams();
        params.forEach((v, k) => {
          if (! fetchUrl.searchParams.has(k)) 
            fetchUrl.searchParams.set(k, v);
          


        });
        fetchUrl.searchParams.set("sections", SECTION_TEMPLATE_KEY);

        const res = await fetch(fetchUrl.toString(), {credentials: "same-origin"});
        if (! res.ok) 
          throw new Error("Network error while loading next page");
        


        const json = await res.json();
        const fragmentHtml = json[SECTION_TEMPLATE_KEY];
        if (! fragmentHtml) 
          throw new Error("Section fragment missing");
        


        const doc = new DOMParser().parseFromString(fragmentHtml, "text/html");

        const newItems = doc.querySelectorAll(`#${CONTAINER_ID} > .collection-grid__item`);
        const currentContainer = document.getElementById(CONTAINER_ID);
        if (currentContainer && newItems.length) {
          newItems.forEach((item) => currentContainer.appendChild(item));

          if (window.initProductCards) {
            window.initProductCards();
          }
        }

        qs(".next-page-link") ?. remove();
        const newNext = doc.querySelector(".next-page-link");
        if (newNext && document.getElementById(GRID_ID)) {
          const merged = new URL(newNext.href, location.origin);
          getFilterParams().forEach((v, k) => {
            if (! merged.searchParams.has(k)) 
              merged.searchParams.set(k, v);
            


          });
          const anchor = document.createElement("a");
          anchor.className = "next-page-link";
          anchor.href = merged.toString();
          anchor.hidden = true;
          document.getElementById(GRID_ID).appendChild(anchor);
        }
      } catch (err) {
        console.error("loadNextPage:", err);
      } finally {
        if (loaderEl) 
          loaderEl.style.display = "none";
        


        loading = false;
      }
    }

    initFilters();
    initInfiniteScroll();
  });

  } catch(e) { console.error(e); }
})();
})();
